import angular from 'angular';

import { RealEstateInterest } from './real-estate-interest.component';

const MODULE_NAME = 'RealEstateInterest';

export default angular.module(MODULE_NAME, []).component('realEstateInterest', RealEstateInterest).name;


